import { GiphyFetch } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { useContext, useRef } from 'react'
import { MAX_PREVIEW_WIDTH } from '../../../constants'
import { UGEContext } from '../../../context'
import { getStickerLayer } from '../../../utilities/layer'
import { Grid } from './style'

type Props = {
    className?: string
    searchTerm: string
}

const UGEStickersEditorGrid = ({ className, searchTerm }: Props) => {
    const { addLayer, apiKey, crop, dimensions, fetchFavoriteStickers, trackGAEvent } = useContext(UGEContext)
    const giphyFetchRef = useRef<GiphyFetch>(new GiphyFetch(apiKey))

    async function fetchGifs(offset: number) {
        if (fetchFavoriteStickers && searchTerm === 'giphyfavorites') {
            return fetchFavoriteStickers(offset)
        }

        if (searchTerm === 'giphytrending') {
            return giphyFetchRef.current.trending({ offset, type: 'stickers' })
        }

        if (searchTerm === 'emoji') {
            return giphyFetchRef.current.emoji({ offset })
        }

        return giphyFetchRef.current.search(searchTerm, { offset, type: 'stickers' })
    }

    async function onGifClick(gif: IGif) {
        const layer = await getStickerLayer(gif, searchTerm, dimensions, crop)

        addLayer(layer)

        trackGAEvent('creation_asset_add', {
            content: {
                contentId: gif.id,
                contentType: gif.is_sticker ? 'sticker' : 'gif',
            },
        })
    }

    return (
        <Grid
            borderRadius={0}
            className={className}
            columns={6}
            fetchGifs={fetchGifs}
            gutter={30}
            hideAttribution
            key={searchTerm}
            noLink
            user={{}}
            noResultsMessage="No stickers found"
            width={MAX_PREVIEW_WIDTH - 60}
            onGifClick={onGifClick}
        />
    )
}

export default UGEStickersEditorGrid
